<template>
  <div class="body">
    <!-- <fuzhen_tabs :paths="docid" /> -->
    <div class="chat-window" ref="chatwindow" :style="chatdata.status!=1?'padding-bottom:8rem':''">
      <audio :src="playbox" ref="playbox" controls style="display: none" preload="auto" :muted="muted"></audio>
      <!--<div class="msgbox nomore" v-if="nomore">暂无更多内容~</div>-->
      <div class="msgbox">
        <div class="system-massage">
          根据《互联网医院管理办法》，患者必须上传实体医疗机构病历才可为患者继续复诊并开具处方，请尽快更新包含同诊断的病历。
          <a
            href="javascript:;"
            @click="bingliShow = true "
          >点此更新病历</a>
        </div>
      </div>
      <div class="msgbox">
        <div class="system-massage">
          已成功购买问诊。医生将在12小时内开始与您沟通，逾期未回复您，您可选择继续等待或
          <a
            :href="'tel:'+$cookies.get('customer_phone')"
          >联系客服</a>
        </div>
      </div>
      <div
        class="massage-box"
        :class="{'I-say':item.ext.from == 'me','U-say':item.ext.from != 'me'}"
        :key="index"
        v-for="(item,index) in chats"
        :data-time="item.timestamp"
      >
        <div
          v-if="item.ext.from == 'me'&&item.to==groupid&&!item.ext.prescriptStatusType&&item.ext.chatType=='TXT'"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content">{{item.body.msg}}</div>
          <br class="clear" />
        </div>
        <!--发出普通消息-->

        <div
          v-if="item.from=='dy_doctor'+chatdata.docInfo.mobile&&item.to==groupid&&!item.ext.prescriptStatusType&&!item.ext.tip&&item.ext.chatType=='TXT'&&!item.ext.videoChat&&!item.ext.statusDesc"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content">{{item.data}}</div>
          <br class="clear" />
        </div>
        <div
          v-if="item.ext.statusDesc==1"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content">{{item.data}}</div>
          <br class="clear" />
        </div>
        <!--收到普通消息-->

        <div
          v-if="item.ext.from=='me'&&item.to==groupid&&!item.ext.tip&&item.ext.chatType=='IMAGE'"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content">
            <img :src="item.file.url" @click="showimg(item.file.url)" />
          </div>
          <br class="clear" />
        </div>
        <!--发出图片消息-->

        <div
          v-if="item.from=='dy_doctor'+chatdata.docInfo.mobile&&item.to==groupid&&!item.ext.tip&&item.ext.chatType=='IMAGE'"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content">
            <img :src="item.url" alt @click="showimg(item.url)" />
          </div>
          <br class="clear" />
        </div>
        <!--收到图片消息-->

        <div
          v-if="item.from=='dy_doctor'+chatdata.docInfo.mobile&&item.to==groupid&&!item.ext.tip&&item.ext.chatType=='VOICE'"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div
            class="massage-content audio-box"
            @click="audioplay($event,item.auurl)"
            ref="audiobox"
          >
            <div class="audio-gif">
              <div class="wifi-symbol">
                <div class="wifi-circle first"></div>
                <div class="wifi-circle second"></div>
                <div class="wifi-circle third"></div>
              </div>
            </div>
            <span class="audio-time">{{item.length}}s</span>
          </div>
          <br class="clear" />
        </div>
        <!--收到语音消息-->

        <div
          v-if="item.from=='dy_doctor'+chatdata.docInfo.mobile&&item.ext.tip&&item.ext.tipStatusType==3&&item.to==groupid"
          class="time-box"
        >
          <div class="user-head">
            <img :src="getavatar(item.ext.from)" alt="" />
          </div>
          <div class="massage-content" @click="showAddbingli">
            <div class="update-record">
              <div class="icon-box">
                <i class="icon icon-updateRecord"></i>
              </div>
              <div class="text-box font-25">
                <h3 class="font-85">上传病历</h3>请上传实体医疗机构病历
              </div>
            </div>
          </div>
          <br class="clear" />
        </div>
        <!--收到上传病历提醒-->

        <!--<div v-if="item.ext.inquiry">
          <div class="card-box">
            <div class="card-content">
              <div class="update-record">
                <div class="icon-box">
                  <i class="icon icon-updateRecord"></i>
                </div>
                <div class="text-box font-25">
                  <h3 class="font-85">上传病历</h3>
                  请上传实体医疗机构病历
                </div>
              </div>
            </div>
            <div class="card-content">
              患者：{{item.ext.patientInfo}}
            </div>
            <div class="card-content">
              病情：{{item.ext.diagnoseInfo}}
            </div>
            <div class="card-content">
              <button class="card-bottom-btn">点此查看患者问诊资料</button>
            </div>
          </div>
        </div>&lt;!&ndash;上传完病历提示&ndash;&gt;-->

        <div v-if="item.ext.prescriptStatusType == 2&&item.to==groupid && !item.ext.yiche"
             class="time-box"
        >
          <div class="card-box">
            <div class="card-content">
              <div class="update-record">
                <div class="icon-box">
                  <i class="icon icon-fangan"></i>
                </div>
                <div class="text-box font-25">
                  <h3 class="font-85">治疗方案-{{item.ext.status}}</h3>
                  {{formatTime(item.timestamp/1000,'Y-M-D h:m:s')}}
                </div>
              </div>
            </div>
            <div class="card-content">患者：{{item.ext.patientInfo}}</div>
            <div class="card-content"><span style="display:inline-block;width:auto;">诊断：</span> {{item.ext.diagnoseInfo}}</div>
            <div class="card-content">
              <button
                class="card-bottom-btn flex_c_c"
                @click="goOrderPay(item.ext.prescriptStatusType,item.ext.orderId)"
              >点此购买</button>
            </div>
          </div>
          <!--收到药方-->
        </div>

        <div v-if="item.ext.prescriptStatusType == 2&&item.to==groupid&&item.ext.yiche"
             class="time-box"
        >
          <div class="card-box">
            <div class="card-content">
              <div class="update-record">
                <div class="icon-box">
                  <i class="icon icon-fangan"></i>
                </div>
                <div class="text-box font-25">
                  <h3 class="font-85">治疗方案-{{item.ext.status}}</h3>
                  {{formatTime(item.timestamp/1000,'Y-M-D h:m:s')}}
                </div>
              </div>
            </div>
            <div class="card-content">患者：{{item.ext.patientInfo}}</div>
            <div class="card-content"><span style="display:inline-block;width:auto;">诊断：</span> {{item.ext.diagnoseInfo}}</div>
            <div class="card-content">
              <button
                class="card-bottom-btn flex_c_c"
                style="background: #919191"
                @click="$toast.center('医生已撤回处方')"
              >已撤回</button>
            </div>
          </div>
          <!--收到药方-->
        </div>

        <div v-if="item.ext.prescriptStatusType == 1&&item.to==groupid"
             class="time-box"
        >
          <div class="system-massage">
            恭喜您，购药成功 <a href="javascript:;" @click="goOrderPay(item.ext.prescriptStatusType,item.ext.orderId)">点此查看</a>
          </div>
        </div>
        <!--药方支付成功-->

        <div v-if="item.ext.prescriptStatusType == 3&&item.to==groupid"
             class="time-box"
        >
          <div class="system-massage">
            医生已撤回处方
          </div>
        </div>
        <!--药方订单撤回-->
        <div v-if="item.ext.inquiry == 1&&item.to==groupid"
             class="time-box"
        >
          <div class="system-massage">
            问诊单资料已经更新~
          </div>
        </div>
        <!--问诊单填写完毕-->

        <!--<div v-if="chatdata.userInfo.unionid == item.from">
          <div class="system-massage">
            根据《互联网医院管理办法》，患者必须上传实体医疗机构病历才可为患者继续复诊并开具处方，请尽快更新包含同诊断的病历。
            <a href="javascript:;">点此更新病历</a>
          </div>
        </div>-->

        <div v-if="item.ext.purchaseService&&item.to==groupid"
             class="time-box"
        >
          <div class="card-box">
            <div class="card-content">
              <div class="update-record">
                <div class="icon-box">
                  <i class="icon icon-fangan"></i>
                </div>
                <div class="text-box font-25">
                  <h3 class="font-85">问诊单</h3>
                  {{formatTime(item.timestamp/1000,'Y-M-D h:m:s')}}
                </div>
              </div>
            </div>
            <div class="card-content">患者：{{item.ext.patientInfo}}</div>
            <div class="card-content">病情：{{item.ext.diagnoseInfo}}</div>
            <div class="card-content">
              <button
                class="card-bottom-btn flex_c_c"
                @click="goeditwenzhen(item.ext.patientID,item.ext.drugsId)"
              >填写问诊单</button>
            </div>
          </div>
        </div>
        <!--开始问诊-->

      </div>
    </div>
    <div class="send-box">
      <div class="servive-item" v-if="chatdata.status!=1">
        <div>
          <p>电话问诊</p>
          <span>电话沟通，在线开方调药</span>
        </div>
        <button
          class="fuzhenbtn"
          :class="{'isdisabled':!isphone}"
          @click="goorder(2)"
        >{{isphone?'点此复诊':'停止接诊'}}</button>
      </div>
      <div class="servive-item" v-if="chatdata.status!=1">
        <div>
          <p>图文问诊</p>
          <span>自由图文交流，开方调药</span>
        </div>
        <button
          class="fuzhenbtn"
          :class="{'isdisabled':!istuwen}"
          @click="goorder(1)"
        >{{istuwen?'点此复诊':'停止接诊'}}</button>
      </div>
      <div class="send-cont">
        <div class="send-img-btn">
          <input
            type="file"
            :disabled="chatdata.status!=1"
            accept="image/*"
            @change="sendimg"
            ref="changeimg"
          />
          <i class="icon icon-send-img"></i>
        </div>
        <textarea
          id="chat-input"
          ref="textarea"
          maxlength="500"
          :disabled="chatdata.status!=1"
          :style="{minHeight:'1.8rem',height:textarea_height}"
          :placeholder="chatdata.status!=1?'购买复诊后和医生说话':''"
          v-model="textarea"
          contenteditable="true"
        ></textarea>

        <button class="send-btn font-85" :class="{'send-btn-dis':chatdata.status !=1}" :disabled="chatdata.status!=1" @click="sendmsg">发送</button>
      </div>
    </div>
    <div class="mask" v-show="bingliShow">
      <div class="bingli-box">
        <h3>上传【实体医疗机构病历资料】</h3>
        <p>根据《互联网医院管理办法》，请上传包含医生诊断及患者信息的处方或病历。</p>
        <div class="imgs-box">
          <div class="send-img">
            <img src="../../../static/docs/bingli.jpg" alt="示例图片" @click="showimg('../../../static/docs/bingli.jpg')"/>
            <span>查看示例</span>
          </div>
          <div class="send-img add-img-border" v-for="(item,index) in imglist" :key="index">
            <img :src="item" @click="showimg(item)" />
          </div>
          <div class="send-img add-img-border up-loading" v-if="loadingimg">
            <img src="../../../static/icons/loading.gif" />
          </div>
          <div class="send-img add-img-border" v-if="imglist.length < 8">
            <input type="file" class="upload" accept="image/*" @change="uploadimg" ref="inputer" />
            <i class="icon icon-add-bingli"></i>
            <p class="upload-txt">点此上传</p>
          </div>
        </div>
        <br class="clear" />
        <p class="max-num">（最多8张）</p>
        <div class="bing-tongyi">
          <i class="icon icon-check" :class="{'icon-checked':tongyi == 1}" @click="xieyi"></i>
          <p>同意将处方或病历上传至互联网医院（本地医生可见）；同意医生更具该处方或病历为患者线上复诊并开具处方</p>
        </div>
        <div class="btns">
          <button class="card-bottom-btn flex_c_c shaohou" @click="showAddbingli">稍后上传</button>
          <button class="card-bottom-btn flex_c_c" :disabled="bingling" @click="subbingli">确认上传</button>
        </div>
      </div>
    </div>
    <div class="mask" v-show="imgshow">
      <span @click="showimg">×</span>
      <img :src="imgsrc" alt />
    </div>
  </div>
</template>
<script>
import fuzhen_tabs from "../../components/fuzhen_tabs/fuzhen_tabs";
import webim from "../../utils/plugin/webim";
import http from "../../request/http";
import store from "@/store";
import calcTextareaHeight from "../../utils/calcTextareaHeight";
import Cookie from "vue-cookies";
export default {
  name: "chat",
  data() {
    return {
      menushow: true,
      docid: "",
      pid: "",
      groupid: "",
      chats: this.$store.state.chats,
      chatdata: {
        docInfo: {
          mobile: "",
          avatar: "",
        },
        userInfo: {
          avatar: "",
        },
        status:1
      },
      fuzhenbtnshow: true,
      isphone: true,
      istuwen: true,
      textarea: "",
      bingliShow: false,
      tongyi: 1,
      imglist: [],
      imgshow: false,
      imgsrc: "",
      status: 1,
      orderid: "",
      playbox: "",
      textarea_height: "1.8rem",
      textarea_max_height: 0,
      loading: false,
      nomore: false,
      bingling: false,
      loadingimg:false,
      muted:true
    };
  },
  watch: {
    textarea() {
      this.getHeight();
    },
  },
  methods: {
    watchScrollTop(e){
      let appbox = document.getElementById("app");
      this.$store.dispatch('getScrollTop',appbox.scrollTop)
      if (this.loading == false && appbox.scrollTop < 10) {
        this.loading = true;
        let msgbox = document.getElementsByClassName("massage-box");
        let times = msgbox[0].attributes["data-time"].nodeValue;
        this.getChats(times);
      }
    },
    getChats(timestamp) {
      let appbox = document.getElementById("app");
      let msgbox = document.getElementsByClassName("massage-box")[0];
      if (!timestamp) timestamp = "";
      http
        .post("/api/wap/chat/message", {
          pid: this.pid,
          docid: this.docid,
          hxgroupid:this.groupid,
          timestamp: timestamp,
        })
        .then((res) => {
          if (res.data && res.data.length == 0) {
            this.nomore = true;
          }
          res.data.forEach((e) => {
            let bodyobj = e.body_array;
            e.ext = bodyobj.ext;
            if (e.ext.chatType == "IMAGE") {
              e.url = e.qnlink;
              e.file = {
                url: e.qnlink,
              };
            } else if (e.ext.chatType == "TXT") {
              e.data = e.content;
              e.body = {
                msg: e.content,
              };

              //e.body.msg = e.content
            } else if (e.ext.chatType == "VOICE") {
              e.auurl = e.qnlink;
              e.length = e.body_array.bodies[0].length;
            } else {
              e.url = "";
              e.auurl = "";
            }
            this.$store.commit("getChat", e);
            console.log(this.$store.state.chats)
            this.loading = false;
          });
          let appbox = document.getElementById("app");
          setTimeout(() => {
            if (appbox.scrollHeight > appbox.clientHeight) {
              //设置滚动条到最底部
              if(this.scroll_top){
                appbox.scrollTop = this.scroll_top;
              }else{
                appbox.scrollTop = appbox.scrollHeight;
              }

            }
          }, 100);
        });
    },
    getHeight() {
      let height = calcTextareaHeight(this.$refs.textarea, 1, null).height;
      this.textarea_height =
        height.slice(0, -2) > this.textarea_max_height
          ? this.textarea_max_height + "px"
          : height;
      if (!this.textarea) {
        this.textarea_height = "1.8rem";
      }
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    formatTime(number, format) {
      var formateArr = ["Y", "M", "D", "h", "m", "s"];
      var returnArr = [];

      var date = new Date(number * 1000);
      returnArr.push(date.getFullYear());
      returnArr.push(this.formatNumber(date.getMonth() + 1));
      returnArr.push(this.formatNumber(date.getDate()));
      returnArr.push(this.formatNumber(date.getHours()));
      returnArr.push(this.formatNumber(date.getMinutes()));
      returnArr.push(this.formatNumber(date.getSeconds()));

      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i]);
      }
      return format;
    },
    goorder(type) {
      if (type == 1 && this.istuwen) {
        this.$router.push({
          name: "wenzhen_order_pay",
          query: {
            doctorid: this.docid,
            type: type,
          },
        });
      } else if (type == 2 && this.isphone) {
        this.$router.push({
          name: "wenzhen_order_pay",
          query: {
            doctorid: this.docid,
            type: type,
          },
        });
      }
    },
    audioplay(e, link) {
      this.playbox = link;
      this.muted = true;
      for (var i = 0; i <= this.$refs.audiobox.length; i++) {
        this.$refs.audiobox[0].classList.remove("ani");
      }

      setTimeout(() => {
        this.$refs.playbox.play();
        this.muted = false;
        e.target.classList.add("ani");
        this.$refs.playbox.addEventListener("ended", () => {
          e.target.classList.remove("ani");
        });
      }, 300);
    },
    showimg(link) {
      if (this.imgshow) {
        this.imgshow = false;
      } else {
        this.imgsrc = link;
        this.imgshow = true;
      }
    },
    uploadimg(e) {
      this.loadingimg = true;
      let inputDOM = this.$refs.inputer;
      this.file = inputDOM.files[0]; // 通过DOM取文件数据
      let size = Math.floor(this.file.size / 1024); //计算文件的大小
      this.formData = new FormData(); //new一个formData事件
      this.formData.append("file", this.file); //将file属性添加到formData里
      http.postFormData("/api/wap/public/upload", this.formData).then((res) => {
        this.loadingimg = false;
        this.imglist.push(res.data.path);
      });
    },
    getavatar(froms) {
      if (froms == "me") {
        return this.chatdata.userInfo.avatar;
      } else {
        return this.chatdata.docInfo.avatar;
      }
    },
    getlishiChats() {
      var options = {
        queue: this.groupid,
        isGroup: true,
        count: 10,
        success: function () {},
        fail: function () {},
      };
      WebIM.conn.fetchHistoryMessages(options);
    },
    goeditwenzhen(pid,oid){
      let qus = this.$route.query;
      qus.pid = pid;
      qus.orderid = oid;
      this.$router.push({
        name:'pat_content',
        query:qus
      })
    },
    subbingli() {
      this.bingling = true;
      if(this.tongyi == 2){
        this.$toast.center("请勾选同意");
        this.bingling = false;
      }else if (this.imglist.length == 0) {
        this.$toast.center("请上传病历");
        this.bingling = false;
      } else {
        http
          .post("/api/wap/case/hospital", {
            pid: this.pid,
            docid: this.docid,
            order_id: this.orderid,
            body: this.imglist,
          })
          .then((res) => {
            this.showAddbingli();
            this.imglist = [];
            this.bingling = false;
          });
      }
    },
    routerClick(path) {
      this.$router.push(path);
    },
    goOrderPay(type, oid) {
      // 未支付
      http.post('/api/wap/order/yaoinfo',{
        order_id:oid
      }).then(res=>{
        this.$router.push({
          name: "order_pay_detail",
          query: {
            orderid: oid
          },
        });

      })

    },
    showAddbingli() {
      if (this.bingliShow) {
        this.bingliShow = false;
      } else {
        this.bingliShow = true;
      }
    },
    xieyi() {
      if (this.tongyi == 1) {
        this.tongyi = 2;
      } else {
        this.tongyi = 1;
      }
    },
    chatInfo() {
      http
        .post("/api/wap/chat/info", {
          pid: this.pid,
          docid: this.docid,
        })
        .then((res) => {
          this.chatdata = res.data;
          this.pid = res.data.userInfo.pid;
          this.orderid = res.data.order_id;
          this.$store.dispatch('getGroupId',res.data.userInfo.hxgroupid);
          this.groupid=res.data.userInfo.hxgroupid;
          res.data.docInfo.is_graphic === 0
            ? (this.istuwen = true)
            : (this.istuwen = false);
          res.data.docInfo.is_phone == 0
            ? (this.isphone = true)
            : (this.isphone = false);
          let times = '';
          this.orderid = res.data.order_id;
          setTimeout(()=>{
            if(document.getElementsByClassName("massage-box").length){
              times = document.getElementsByClassName("massage-box")[0].attributes["data-time"].nodeValue;
            }
            this.getChats(times);
          },500)

        });
    },
    sendmsg() {
      if (this.textarea != "") {
        let msgId = WebIM.conn.getUniqueId();
        let msgobj = new WebIM.message("txt", msgId);
        var option = {
          msg: this.textarea, // 这儿是发送的消息内容
          to: this.groupid, // 接收消息对象(聊天室id) this.groupid
          roomType: false,
          chatType: "groupChat",
          from:this.$cookies.get('app_token'),
          // 这儿的ext是自定义属性，安卓端可以根据这个属性获取信息,以name、age为例（与安卓商量着来）
          ext: {
            from: "me",
            chatType: "TXT",
          },
          type: "groupchat",
          success: (id, res) => {
            let nbody = msgobj.body;
            msgobj.body.body = {
              ext:nbody.ext,
              from:nbody.from,
              msg:nbody.msg,
              to:nbody.to
            };
            this.$store.commit("updateChats", msgobj.body);
            this.textarea = "";
          },
          fail: (res) => {
            this.$message.error("信息发送失败");
          },
        };
        msgobj.set(option);
        msgobj.setGroup("groupchat");
        this.$imConn.send(msgobj.body);
        let appbox = document.getElementById("app");
        setTimeout(() => {
          if (appbox.scrollHeight > appbox.clientHeight) {
            //设置滚动条到最底部
            appbox.scrollTop = appbox.scrollHeight;
          }
        }, 300);
      } else {
        this.$toast.center("不能发送空消息");
      }
    },
    sendimg(e) {
      let elimg = this.$refs.changeimg;
      let msgId = this.$imConn.getUniqueId();
      let msg = new WebIM.message("img", msgId);
      let file = WebIM.utils.getFileUrl(e.target);
      if(file){
        var option = {
          apiUrl: WebIM.config.apiURL,
          file: file,
          ext: {
            from: "me",
            chatType: "IMAGE",
          },
          to: this.groupid, // 接收消息对象
          roomType: false,
          chatType: "groupchat",
          onFileUploadError: () => {
            // 消息上传失败
            console.log("上传失败");
          },
          onFileUploadComplete: (data) => {
            // 消息上传成功
            console.log("上传成功");
            console.log(data);
            /*let url = window.URL.createObjectURL(elimg.files[0]);
                msg.body.url=url;*/
            console.log(msg)
            this.$store.commit("updateChats", msg.body);
            elimg.files[0] = "";
          },
          success: () => {
            // 消息发送成功
            console.log("发送成功");
            console.log(file)
          },
          flashUpload: WebIM.flashUpload,
        };
        this.$imConn.send(msg.body);
        msg.set(option);
        msg.setGroup("groupchat");
        this.$imConn.send(msg.body);
        let appbox = document.getElementById("app");
        setTimeout(() => {
          if (appbox.scrollHeight > appbox.clientHeight) {
            //设置滚动条到最底部
            appbox.scrollTop = appbox.scrollHeight;
          }
        }, 300);
      }

    },
  },
  components: {
    fuzhen_tabs,
  },
  computed:{
    scroll_top(){
      return this.$store.state.scroll_top;
    }
  },
  created() {
    let docid = this.$route.query.doctorid;
    let pid = this.$route.query.pid;
    let groupid = this.$route.query.groupid?this.$route.query.groupid:'';
    if(groupid){
      this.$store.dispatch('getGroupId',groupid);
      this.groupid = groupid;
    }
    this.docid = docid;
    this.pid = pid;
    if (this.$route.query.name) {
      document.title = this.$route.query.name + "医生的对话";
    }
    this.chatInfo();
  },
  mounted() {
    if (this.$refs.textarea.offsetHeight) {
      this.textarea_max_height = (this.$refs.textarea.offsetHeight / 1.5) * 5;
    }

    let appbox = document.getElementById("app");
    appbox.addEventListener("scroll", this.watchScrollTop);
     /*this.$imConn.listen({
       onTextMessage: (message) => {
         this.$store.commit("updateChats", message);
         if (message.ext.tip && message.ext.tipStatusType == 1) {
           setTimeout(() => {
             location.reload();
           }, 300);
         }
         setTimeout(() => {
           if (appbox.scrollHeight > appbox.clientHeight) {
             //设置滚动条到最底部
             appbox.scrollTop = appbox.scrollHeight;
           }
         }, 300);
       },
       onAudioMessage: function (message) {
         let options = {
           url: message.url,
           headers: { Accept: "audio/mp3" },
           accessToken: Cookie.get("accessToken"),
           onFileDownloadComplete: function (response) {
             let objectUrl = WebIM.utils.parseDownloadResponse.call(
               WebIM.conn,
               response
             );
             message.auurl = objectUrl;
             store.commit("updateChats", message);
           },
           onFileDownloadError: function () {
             console.log("音频下载失败");
           },
         };
         WebIM.utils.download.call(WebIM.conn, options);
         console.log(store.state.chats);

       },
       onPictureMessage: function (message) {
         console.log("textmessage" + message);
         store.commit("updateChats", message);
         console.log(store.state.chats);
         setTimeout(() => {
           if (appbox.scrollHeight > appbox.clientHeight) {
             //设置滚动条到最底部
             appbox.scrollTop = appbox.scrollHeight;
           }
         }, 300);
       }, // 收到图片消息
     });*/
  },
  destroyed(){
    this.$store.dispatch('getGroupId','');
    let appbox = document.getElementById("app");
    appbox.removeEventListener('scroll', this.watchScrollTop);
  }
};
</script>

<style scoped>
.body {
  padding: 0.9rem 0 3rem 0;
}
.flex_c_c{
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.chat-window {
  padding: 0 0.5rem;
}
.icon-add-bingli {
  content: url("../../../static/icons/add@3x.png");
  width: 0.9rem;
  height: 0.9rem;
  position: absolute;
  top: 1.2rem;
  left: 1.5rem;
}

.bingli-box .upload-txt {
  width: 100%;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.7rem;
  color: rgba(24, 144, 255, 1);
  position: absolute;
  bottom: 0.25rem;
  left: 0;
  text-align: center;
  margin: 0;
}
.imgs-box {
  overflow: auto;
  max-height: 6.5rem;
}
.massage-box {
  width: 100%;
  height: auto;
  /*display: flex;
    align-items: flex-start;
    justify-content: flex-start;*/
  margin-bottom: 1rem;
  font-size: 0.8rem;
}
.msgbox {
  width: 100%;
  height: auto;
  /*display: flex;
    align-items: flex-start;
    justify-content: flex-start;*/
  margin-bottom: 1rem;
  font-size: 0.7rem;
}
.massage-content {
  width: auto;
  height: auto;
  padding: 0.5rem;
  background: #fff;
  border-radius: 0 0.6rem 0.6rem 0.6rem;
  margin: 0 0.5rem;
  max-width: 13rem;
  text-align: justify;
  position: relative;
  float: left;
  border: 0.05rem solid rgba(245, 245, 245, 1);
  word-break: break-word;
}
.massage-content img {
  max-width: 100%;
  max-height: 10rem;
}
.massage-box.I-say .massage-content {
  float: right;
  background: #e6f7ff;
  border-radius: 0.6rem 0 0.6rem 0.6rem;
}
.massage-box.I-say .user-head {
  float: right;
}
.user-head {
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  overflow: hidden;
  float: left;
}
.user-head img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.send-box {
  width: 100%;
  min-height: 3rem;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  border-top: 0.05rem solid rgba(232, 232, 232, 1);
  padding: 0 0.6rem;
}
.servive-item {
  width: 100%;
  height: 3.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.05rem solid #f5f5f5;
}
.servive-item p {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.85);
}
.servive-item span {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.45);
}
.fuzhenbtn {
  width: 4.4rem;
  height: 1.8rem;
  border-radius: 0.9rem;
  border: none;
  color: #fff;
  background: #1890ff;
  line-height: 1.8rem;
  font-size: 0.8rem;
}
.fuzhenbtn.isdisabled {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
}
.send-cont {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 3rem;
  padding: 0.3rem 0;
}
.send-img-btn {
  width: 0.9rem;
  height: 0.9rem;
  position: relative;
  margin: 0.35rem  0 0;
}
.send-img-btn input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.icon-send-img {
  content: url("../../../static/icons/send_img.png");
  width: 0.9rem;
  height: 0.9rem;
  vertical-align: top;
}
#chat-input {
  width: 13.95rem;
  height: 1.8rem;
  background: #fff;
  border: 0.025rem solid rgba(232, 232, 232, 1);
  resize: none;
  padding: 0.2rem;
  outline: none;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 0.2rem;
  -webkit-appearance: none;
  line-height: 1.2rem;
  box-sizing: border-box;
}
#chat-input:disabled {
  background: #fff;
  border: none;
  border-bottom: 0.05rem solid rgba(232, 232, 232, 1);
}
.send-btn {
  background: none;
  border: none;
  font-size: 0.7rem;
  height: 100%;
  outline: none;
  text-align: right;
  margin-top: 0.35rem;
}
.send-btn-dis{
  color:rgba(0,0,0,.25)
}
.system-massage {
  padding: 0.4rem 0.6rem;
  line-height: 1rem;
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
  border-radius: 0.4rem;
  width:fit-content;
  margin: 0 auto;
  text-align: center;
}
.system-massage a {
  color: #1890ff;
}
.icon-box {
  width: 2.5rem;
  height: 2.5rem;
  background: #f0f5ff;
  margin-right: 0.5rem;
}
.icon-updateRecord {
  content: url("./../../../static/icons/upload_medical_records@2x.png");
  width: 2.5rem;
  height: 2.5rem;
}
.icon-fangan {
  content: url("./../../../static/icons/chinese_herbal_pieces@3x.png");
  width: 2.5rem;
  height: 2.5rem;
}
.update-record {
  display: flex;
  width: 11rem;
  justify-content: start;
  align-items: center;
}
.text-box {
  font-size: 0.7rem;
  line-height: 1rem;
}
.text-box h3 {
  font-size: 1rem;
  font-weight: 700;
  font-weight: 700;
  margin: 0.3rem 0;
}
.card-box {
  width: 16.5rem;
  height: auto;
  background: #fff;
  border: 0.05rem solid rgba(245, 245, 245, 1);
  border-radius: 0.6rem;
  margin: 0 auto;
  padding: 1rem;
  background-image: url("./../../../static/icons/superscript@2x.png");
  background-repeat: no-repeat;
  background-size: 1rem 1.2rem;
  background-position: 14.3rem 0rem;
}
.card-content {
  border-bottom: 0.05rem solid #f5f5f5;
  line-height: 2.8rem;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}
.card-content:last-child {
  border-bottom: none;
}
.card-content .update-record {
  margin-bottom: 1rem;
}
.card-bottom-btn {
  width: 100%;
  height: 2rem;
  text-align: center;
  border: none;
  background: #1890ff;
  color: #fff;
  /* line-height: 2rem; */
  font-size: 0.8rem;
  border-radius: 1rem;
  margin-top: 1rem;
}
.bingli-box {
  width: 15.8rem;
  min-height: 22.3rem;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12.15rem;
  margin-left: -7.9rem;
  border-radius: 0.6rem;
  padding: 1rem;
}
.bingli-box h3 {
  font-size: 0.9rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.9rem;
  margin-bottom: 0.5rem;
}
.bingli-box p {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 1rem;
}
.send-img {
  width: 3.9rem;
  height: 3.9rem;
  float: left;
  margin-right: 0.85rem;
  position: relative;
  margin-bottom: 0.4rem;
  border: 0.05rem solid rgba(232, 232, 232, 1);
}
.add-img-border {
  border-style: dashed;
}
.send-img img {
  width: 100%;
  height: 100%;
}
.send-img span {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.2rem;
  background: #1890ff;
  color: #fff;
  font-size: 0.7rem;
  text-align: center;
  line-height: 1.2rem;
}
.send-img:nth-child(3n) {
  margin-right: 0;
}
p.max-num {
  text-align: center;
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.25);
  display: block;
}
.bing-tongyi {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.bing-tongyi p {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.25);
  text-align: left;
  width: calc(100% - 1.4rem);
}
.shaohou {
  margin-right: 1.2rem;
  background: #fff;
  color: rgba(0, 0, 0, 0.85);
  border: 0.05rem solid #e8e8e8;
}
.btns {
  padding: 0;
}
.btns .card-bottom-btn {
  margin-top: 0;
}
.mask {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 2rem 1rem;
}
.mask > span {
  color: #fff;
  font-size: 2rem;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.mask > img {
  max-width: 100%;
  max-height: 100%;
}
.massage-box.U-say .massage-content .audio-gif {
  float: left;
}
.massage-box.I-say .massage-content .audio-gif .second {
  width: 0.7rem;
  height: 0.7rem;
  bottom: 0.5rem;
  right: 0.5rem;
}
.ani .second {
  animation: fadeInOut 1s infinite 0.2s;
}
.ani .third {
  animation: fadeInOut 1s infinite 0.4s;
}
.massage-box.U-say .massage-content .audio-time {
  margin-left: 1rem;
}
.massage-box.U-say .massage-content .audio-gif .first {
  width: 0;
  height: 0;
  background: #ccc;
  top: 0.8rem;
  left: 0.8rem;
}
.massage-box.U-say .massage-content .audio-gif .second {
  width: 0.7rem;
  height: 0.7rem;
  top: 0.5rem;
  left: 0.5rem;
}
.massage-box.U-say .massage-content .audio-gif .third {
  width: 1.2rem;
  height: 1.2rem;
  top: 0.2rem;
  left: 0.2rem;
}
.audio-box {
  line-height: 1rem;
}
.massage-box.U-say .massage-content .audio-time {
  margin-left: 1rem;
}
.audio-gif {
  width: 1rem;
  height: 1rem;
  box-sizing: border-box;
  position: relative;
}
.wifi-symbol {
  width: 1rem;
  height: 1rem;
  box-sizing: border-box;
  overflow: hidden;
  transform: rotate(135deg);
}
.wifi-circle {
  border: 0.1rem solid rgba(0, 0, 0, 0.85);
  border-radius: 50%;
  position: absolute;
}
.nomore {
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
}
.top-tishi {
  width: 100vw;
  height: 3rem;
  position: fixed;
  top: 2.4rem;
  left: 0;
  background: #ffffb8;
  padding: 0.4rem 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9;
}
.icon-enter {
  content: url("../../../static/icons/enter@3x.png");
  width: 0.6rem;
  height: 1rem;
}
.top-tishi p {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.2rem;
}
.top-tishi span {
  font-size: 0.6rem;
  color: #fa541c;
}
.up-loading{
  background: rgba(0,0,0,0.02);
  display: flex;
  align-items: center;
  justify-content: center;
}
.send-img.up-loading img{
  width: 1.5rem;
  height: 1.5rem;
}
.audio-box audio{
  width: 10rem;
  height:2rem;
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/chat.vue